module.exports = __webpack_public_path__ + "img/BD.32e1ddfa.svg";